<script setup lang="ts">
import NuxtLinkFlat from '~theme/components/atoms/NuxtLinkFlat.vue';

const props = defineProps<{
  disabled?: boolean;
  seminarId: string;
  timerexUrl?: string;
  variant: 'whiteBg' | 'whiteBgOnMobile';
}>();

const external = computed(() => !!props.timerexUrl);

const { longSessionId } = useSession();

const route = useRoute();
const addPrefix = (obj: object, prefix: string) =>
  Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [`${prefix}${key}`, value])
  );

const pickIfKeyExists = (obj: object, ...keys: string[]) =>
  Object.fromEntries(
    Object.entries(obj).filter(([key, _]) => keys.includes(key))
  );

const href = computed(() =>
  props.timerexUrl
    ? {
        path: props.timerexUrl,
        query: addPrefix(
          {
            ...pickIfKeyExists(
              route.query,
              'utm_source',
              'utm_medium',
              'utm_campaign',
              'utm_content'
            ),
            long_session_id: longSessionId.value,
            seminar_id: props.seminarId,
          },
          'X_OKANEKO_'
        ),
      }
    : {
        path: `/seminar/${props.seminarId}/entry`,
        query: pickIfKeyExists(route.query, 'inflow_source'),
      }
);

const label = computed(() =>
  props.disabled
    ? '申し込み可能な日時がありません'
    : 'このマネーセミナーに申し込む'
);
</script>

<template>
  <div :class="[$style.wrapper, $style[`wrapper--${variant}`]]">
    <NuxtLinkFlat
      :class="$style.wrapper__button"
      variant="primary"
      size="large"
      :href="href"
      :external="external"
      :disabled="disabled"
      >{{ label }}</NuxtLinkFlat
    >
  </div>
</template>

<style module lang="scss">
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $color-surface-secondary;
  border-radius: 8px;
  padding: 16px 0;

  &__button {
    @include mobile-only {
      width: 100%;
    }
  }

  &--whiteBg {
    background-color: $color-surface-primary;
    border-radius: 0;
  }

  &--whiteBgOnMobile {
    @include mobile-only {
      background-color: $color-surface-primary;
      border-radius: 0;
    }
  }
}
</style>
